import { Link, useLocation } from "react-router-dom";
import { SECTORS } from "@/lib/omSectors";
import { NAVY, GOLD, MUTED } from "@/components/om/OmBits";

/** Sticky bar: logo left, scrollable sector links centre, gold trial CTA right. */
export const SectorNav = () => {
  const { pathname } = useLocation();
  return (
    <header
      className="sticky top-0 z-50 border-b"
      style={{ background: "rgba(10,22,40,0.96)", backdropFilter: "blur(10px)", borderColor: "rgba(201,168,76,0.2)" }}
      data-testid="sector-nav"
    >
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 h-14 flex items-center gap-4">
        <Link to="/" className="flex items-baseline shrink-0" data-testid="sector-nav-logo">
          <span className="text-white font-bold text-[15px]">Plan</span>
          <span className="font-bold text-[15px]" style={{ color: GOLD }}>-</span>
          <span className="text-white font-bold text-[15px]">Sarthi</span>
        </Link>
        <nav className="flex-1 min-w-0 flex gap-1 overflow-x-auto no-scrollbar" data-testid="sector-nav-links">
          {SECTORS.map((s) => {
            const active = pathname === `/om/sectors/${s.slug}`;
            return (
              <Link
                key={s.slug}
                to={`/om/sectors/${s.slug}`}
                className="px-2.5 py-1.5 text-[11.5px] whitespace-nowrap transition-colors duration-150"
                style={{ color: active ? GOLD : MUTED, background: active ? `${GOLD}14` : "transparent", borderRadius: 6 }}
              >
                {s.name}
              </Link>
            );
          })}
        </nav>
        <Link to="/signup" className="shrink-0 font-semibold text-[12.5px]" style={{ background: GOLD, color: NAVY, borderRadius: 8, padding: "9px 16px" }} data-testid="sector-nav-trial-btn">
          Start Free Trial
        </Link>
      </div>
    </header>
  );
};
